import { render } from "./DespachoInforme.vue?vue&type=template&id=516a9048"
import script from "./DespachoInforme.vue?vue&type=script&lang=js"
export * from "./DespachoInforme.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/informes/DespachoInforme.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "516a9048"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('516a9048', __exports__)) {
    api.reload('516a9048', __exports__)
  }
  
  module.hot.accept("./DespachoInforme.vue?vue&type=template&id=516a9048", () => {
    api.rerender('516a9048', render)
  })

}


export default __exports__